<template>
  <div>
    <form
        @submit.prevent="submitForm"
        class="ecommerce-form action-buttons-fixed"
        novalidate
    >
      <div class="row" v-if="Object.keys(settings).length">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-toggle-right"></i>
                  <h2 class="card-big-info-title">Postavke bestsellera</h2>
                  <p class="card-big-info-desc">Definirajte osnovne parametre.</p>
                </div>
                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.settings.lookbackDays.$anyError }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Broj dana unazad
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <input
                          type="number"
                          min="0"
                          step="1"
                          class="form-control form-control-modern"
                          v-model.number="settings.lookbackDays"
                        />
                      </div>
                      <form-error
                        :model="$v.settings.lookbackDays"
                        :dirty="$v.$dirty"
                        label="Broj dana unazad"
                      />
                      <small class="text-muted d-block mt-2">
                        Period u kojem se broji prodaja artikala. Ako je 0, gleda se cjelokupna prodaja bez ograničenja.
                      </small>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    :class="{ 'has-danger': $v.settings.articleCount.$anyError }"
                  >
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end">
                      Broj artikala
                    </label>
                    <div class="col-lg-7 col-xl-8">
                      <div class="switch switch-success">
                        <input
                          type="number"
                          min="0"
                          max="10"
                          step="1"
                          class="form-control form-control-modern"
                          v-model.number="settings.articleCount"
                        />
                      </div>
                      <form-error
                        :model="$v.settings.articleCount"
                        :dirty="$v.$dirty"
                        label="Broj artikala"
                      />
                      <small class="text-muted d-block mt-2">
                        Koliko se najprodavanijih artikala prikazuje (0 – 10). Ako je 0, prikazuje se 5 artikala.
                      </small>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <div class="col-lg-7 col-xl-8 offset-lg-5 offset-xl-3">
                      <small class="text-muted d-block">
                        Lista se kešira i osvježava svakih sat vremena, pa promjene nisu odmah vidljive na webshopu.
                        U obzir se uzimaju samo artikli vidljivi na webu i označeni kao B2C proizvod.
                      </small>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="row action-buttons">
        <div class="col-12 px-md-0 mt-3 mt-md-0 d-flex justify-content-end gap-3">
          <button
            type="submit"
            class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { translations } from '@/mixins';
import api from '@/services/api';
import validations from './validation-schema/bestsellers-settings';
import FormError from '@/components/shared/form-errors/FormError.vue';

export default {
  name: 'B2CBestsellersSettings',
  mixins: [translations],
  components: { FormError },
  validations: {
    settings: validations,
  },
  data() {
    return {
      key: 'BestsellersSettings',
    };
  },
  methods: {
    submitForm() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$toast.error(this.translations.forms.notValid);
        this.$nextTick(() => {
          const elem = document.querySelector('.has-danger');
          if (elem) elem.scrollIntoView(true);
        });
        return;
      }

      api.updateB2CSettings(this.key, this.settings).then((response) => {
        this.$toast.info(response.data.info);
      }).catch((err) => {
        this.$toast.error(err.response.data.info);
      });
    },
  },
  computed: {
    settings() {
      return this.$store.getters.getB2CSettings;
    },
  },
  mounted() {
    this.$store.dispatch('getB2CSettings', this.key);
  },
  destroyed() {
    this.$store.commit('INIT_B2C_SETTINGS', {});
  },
};
</script>
